import styled, { css } from "styled-components";

import ColormapInterface from "shared-types/colormapinterface";
import { borderRadius, getSpacing } from "stylesheetB2b";

const Z_INDEX = 1;
const OPACITY = 0.8;

export const ButtonContainer = styled.div<{
  colors: ColormapInterface;
  top?: boolean;
}>`
  position: absolute;
  z-index: ${Z_INDEX};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ colors }) => colors.scrollButton};
  padding: ${getSpacing(2)};
  background-color: ${({ colors }) => colors.lastSongHeader};
  border-radius: ${borderRadius.XXXLarge};
  opacity: ${OPACITY};
  margin: ${getSpacing(1)};
  right: ${getSpacing(26)};
  height: ${getSpacing(6)};
  width: ${getSpacing(6)};
  ${({ top }) =>
    top
      ? css`
          top: ${getSpacing(12)};
        `
      : css`
          bottom: 100px;
        `}
`;
